export const GET_FISERV_CONFIG_REQUESTED = 'brand/GET_FISERV_CONFIG_REQUESTED';
export const GET_FISERV_CONFIG_SUCCESS = 'brand/GET_FISERV_CONFIG_SUCCESS';
export const GET_FISERV_CONFIG_FAILURE = 'brand/GET_FISERV_CONFIG_FAILURE';

export const UPDATE_FISERV_CONFIG_REQUESTED = 'brand/UPDATE_FISERV_CONFIG_REQUESTED';
export const UPDATE_FISERV_CONFIG_SUCCESS = 'brand/UPDATE_FISERV_CONFIG_SUCCESS';
export const UPDATE_FISERV_CONFIG_FAILURE = 'brand/UPDATE_FISERV_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  fiservList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_FISERV_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
        fiservList: [],
      };
    }
    case GET_FISERV_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        fiservList: action.result,
      };
    }
    case GET_FISERV_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        fiservList: [],
      };
    }
    case UPDATE_FISERV_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_FISERV_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_FISERV_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getFiserv = (brandId) => {
  return {
    types: [GET_FISERV_CONFIG_REQUESTED, GET_FISERV_CONFIG_SUCCESS, GET_FISERV_CONFIG_FAILURE],
    promise: client => client.get(`getFiserv/${brandId}`)
  };
};

export const updateFiserv = (brandId, data) => {
  return {
    types: [UPDATE_FISERV_CONFIG_REQUESTED, UPDATE_FISERV_CONFIG_SUCCESS, UPDATE_FISERV_CONFIG_FAILURE],
    promise: client => client.post(`updateFiserv/${brandId}`, { data })
  };
};
